export var isTouchDevice = function () { return 'ontouchstart' in window; };
